import { apiSlice } from "./apiSlice";
export const procurementTrackerSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getAllProcurementTracker: builder.query({
            query: (params) => ({
                url: `ProcurementSitc`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["AllProcurementTracker"],
        }),
        getProcurementTrackerDetail: builder.query({
            query: (req) => ({
                url: `ProcurementSitc/${req}`,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),
        addProcurementTracker: builder.mutation({
            query: (body) => ({
                url: `ProcurementSitc`,
                method: 'POST',
                body,
            }),
            invalidatesTags: ['AllProcurementTracker']
        }),

        editProcurementTracker: builder.mutation({
            query: (body) => ({
                url: `ProcurementSitc`,
                method: 'PUT',
                body,
            }),
            invalidatesTags: ['AllProcurementTracker']
        }),

        deleteProcurementTracker: builder.mutation({
            query: (procurementSitcId) => ({
                url: `ProcurementSitc/${procurementSitcId}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['AllProcurementTracker']
        }),
        getExportAllProcurementTracker: builder.query({
            query: (params) => ({
                url: `ProcurementSitc`,
                params,
            }),
            keepUnusedDataFor: 0,
        }),

    }),
});

export const {
    useLazyGetAllProcurementTrackerQuery,
    useEditProcurementTrackerMutation,
    useAddProcurementTrackerMutation,
    useGetAllProcurementTrackerQuery,
    useGetProcurementTrackerDetailQuery,
    useDeleteProcurementTrackerMutation,
    useLazyGetExportAllProcurementTrackerQuery
} = procurementTrackerSlice;
